// extracted by css-extract-rspack-plugin
export default {"card-arrow-separator":"card-arrow-separator-cfidqk","cardArrowSeparator":"card-arrow-separator-cfidqk"};